import { createContext, useContext } from 'react';

export const VisitorIdContext = createContext<string>('visitorId-fallback');

export const useVisitorId = (): string => {
  return useContext(VisitorIdContext);
};
